import { axiosInstance, live_instance } from "../instance";

// const beforeURL = '/api/live'
let beforeURL = ''
/**==========================================================服务器组========================================================= */
/**获取服务器组列表 */
export const getServiceGroupListApi = (current, pageSize) => live_instance({  method: 'get', url:`${beforeURL}/live/api/web/balance/server/group/list`, params: {current, pageSize}}, )

/** 删除服务器组列表 */
export const deleteServiceGroupApi = (id) => live_instance({  method: 'delete', url:`${beforeURL}/live/api/web/balance/server/group/delete/${id}`, }, )

/** 更新服务器组列表 */
export const updateServiceGroupApi = (id, name) => live_instance({  method: 'put', url:`${beforeURL}/live/api/web/balance/server/group/update`, params: {id, name} }, )

/** 添加服务器组列表 */
export const addServiceGroupApi = (name) => live_instance({  method: 'post', url:`${beforeURL}/live/api/web/balance/server/group/add`, params:{name}}, )


/**===========================================================服务器信息================================================================= */
/**根据分组id查询对应的服务器信息 */
export const getServiceInfoApi = (groupId) => live_instance({  method: 'get', url:`${beforeURL}/live/api/web/server/info/info/${groupId}` }, )

/**添加服务器信息（绑定） */
export const addServiceInfoApi = (data) => live_instance({  method: 'post', url:`${beforeURL}/live/api/web/server/info/add`, data, type:'json' }, )

/**删除服务器绑定信息 */
export const deleteServiceInfoApi = (id) => live_instance({  method: 'delete', url:`${beforeURL}/live/api/web/server/info/delete/${id}`, }, )

/** 更新服务器绑定信息 */
export const updateServiceInfoApi = (data) => live_instance({  method: 'put', url:`${beforeURL}/live/api/web/server/info/update`, data, type:'json' },  )


/** 测试配置 */
/**获取测试配置列表 */
export const getTestConfigListApi = (params) => live_instance({  method: 'get', url:`${beforeURL}/live/api/web/test/config/list`, params }, )

/**删除测试配置列表 */
export const deleteTestConfigApi = (id) => live_instance({  method: 'delete', url:`${beforeURL}/live/api/web/test/config/delete/${id}`, }, )

/** 添加测试配置 */
export const addTestConfigApi = (data) => live_instance({  method: 'post', url:`${beforeURL}/live/api/web/test/config/add`, data, type:'json' }, )

/** 更新测试配置 */
export const updateTestConfigApi = (data) => live_instance({  method: 'put', url:`${beforeURL}/live/api/web/test/config/update`, data, type:'json' },  )




